import { render } from "./manage-programs-onboarding-template.vue?vue&type=template&id=a8582bae&lang=pug"
import script from "./manage-programs-onboarding-template.vue?vue&type=script&lang=js"
export * from "./manage-programs-onboarding-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__